"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactColor = require("react-color");

var _clsx = _interopRequireDefault(require("clsx"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _ColorPicker = _interopRequireDefault(require("./ColorPicker.style"));

var _dec, _class;

let ColorPicker = (_dec = (0, _reactJss.default)(_ColorPicker.default), _dec(_class = (0, _reactClickOutside.default)(_class = class ColorPicker extends _react.PureComponent {
  // Handler for click outside of component
  handleClickOutside() {
    const {
      onClose
    } = this.props;
    onClose();
  }

  render() {
    const {
      classes,
      id,
      className,
      visibility,
      value,
      disableAlpha,
      onChange
    } = this.props;
    return _react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.colorPicker, {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      })
    }, _react.default.createElement(_reactColor.ChromePicker, {
      color: value,
      onChange: onChange,
      disableAlpha: disableAlpha
    }));
  }

}) || _class) || _class);
ColorPicker.defaultProps = {
  visibility: 'visible',
  disableAlpha: false,
  onChange: () => {},
  onClose: () => {}
};
var _default = ColorPicker;
exports.default = _default;